module.exports = __webpack_public_path__ + "static/media/map.b2311ec9.svg";